const id_master_user = {
    "": "pengguna",
    add: "tambah pengguna",
    edit: "ubah pengguna",

    error: {
        warehouse: "Minimal 1 gudang.",
        profile: "Profil tidak boleh kosong.",
        create: "Gagal membuat pengguna.",
        edit: "Gagal mengubah pengguna.",
    },

    success: {
        create: "Berhasil membuat pengguna.",
        edit: "Berhasil mengubah pengguna.",
    },
}

export default id_master_user;